import { useContext, useState } from "react";

import {
  AiFillDashboard,
  AiOutlineLogout
} from "react-icons/ai";

import {
  MdBedroomParent,
  MdBookOnline,
  MdInventory2
} from "react-icons/md";

import { FaRegCalendarAlt } from "react-icons/fa";

import { RiBillLine } from "react-icons/ri";
import { RiPriceTag3Line } from "react-icons/ri";

import Dashboard from "../components/Dashboard/Dashboard";
import Inventory from "../components/Inventory/InventoryPage";
import Calendar from "../components/Calendar";
import Bills from "../components/Bills";
import Book from "../components/Book";
import TarifsPage from "../components/Tarifs/TarifsPage";
import Rooms from "../components/Rooms/Rooms";
import Cookies from "js-cookie";


import { AuthAdminContext } from "../../clients/utils/AuthAdminContext";


import "./Admin.css";
import { Link } from "react-router-dom";

export default function Admin() {

  const [activePage, setActivePage] = useState("dashboard");
  const { dispatch } = useContext(AuthAdminContext);

  const renderPage = () => {
    switch (activePage) {

      case "rooms":
        return <Rooms setActivePage={setActivePage} />;

      case "inventory":
        return <Inventory />;

      case "tarifs":
        return <TarifsPage />;

      case "calendar":
        return <Calendar />;

      case "bills":
        return <Bills />;

      case "book":
        return <Book />;

      default:
        return <Dashboard />;
    }
  };

  return (

    <div className="admin-wrapper">

      <div className="admin-container">

        {/* SIDEBAR */}

        <div className="sidebar">

          <div className="logo">
            Komorotel
          </div>

          <div className="menu">

            {[
              { key: "dashboard", icon: <AiFillDashboard /> },

              { key: "rooms", icon: <MdBedroomParent /> },

              { key: "inventory", icon: <MdInventory2 /> },

              { key: "tarifs", icon: <RiPriceTag3Line /> },

              { key: "calendar", icon: <FaRegCalendarAlt /> },

              { key: "book", icon: <MdBookOnline /> },

              { key: "bills", icon: <RiBillLine /> },

            ].map((item) => (

              <div
                key={item.key}
                className={`menu-item ${activePage === item.key ? "active" : ""}`}
                onClick={() => setActivePage(item.key)}>

                {item.icon}

              </div>

            ))}

          </div>

          
    <Link
      to="/"
      className="menu-item"
      onClick={() => {
        dispatch({ type: "ADMIN_LOGOUT" });
        Cookies.remove("admin_token", {
          path: "/",
          domain: ".komorotel.com",
        });
      }}
    >
      <AiOutlineLogout />
    </Link>

        </div>

        {/* MAIN */}

        <div className="main">

          <div className="content">

            {renderPage()}

          </div>

        </div>

      </div>

    </div>

  );
}